import { __assign, __rest } from "tslib";
import React from 'react';
import { components } from 'react-select';
export var CustomInput = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var newProps = __assign(__assign({}, props), { name: props.selectProps.selectProps.name });
    return React.createElement(components.Input, __assign({}, newProps), children);
};
